import React, { useState } from "react";

function Stats() {
    const [activeFilter, setActiveFilter] = useState("Today");

    return (
        <div id="section-stats" className="spanel active">
            <div className="main-wrap" style={{ padding: "18px 0" }}>
                <div className="fbar">
                    <button className={`fbtn ${activeFilter === "Today" ? "active" : ""}`} onClick={() => setActiveFilter("Today")}>Today</button>
                    <button className={`fbtn ${activeFilter === "This Week" ? "active" : ""}`} onClick={() => setActiveFilter("This Week")}>This Week</button>
                    <button className={`fbtn ${activeFilter === "All Time" ? "active" : ""}`} onClick={() => setActiveFilter("All Time")}>All Time</button>
                </div>

                <div className="s2col">
                    <div className="sfull">
                        <div className="sfh">Top Run Scorers (e)</div>
                        <div style={{ padding: "20px", color: "var(--text2)", textAlign: "center" }}>
                            🚧 Under Development
                        </div>
                    </div>
                    <div className="sfull">
                        <div className="sfh">Top Wicket Takers (e)</div>
                        <div style={{ padding: "20px", color: "var(--text2)", textAlign: "center" }}>
                            🚧 Under Development
                        </div>
                    </div>
                </div>

                <div className="sh">Highest Team Scores</div>
                <div className="sfull">
                    <div style={{ padding: "20px", color: "var(--text2)", textAlign: "center" }}>
                        🚧 Under Development
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Stats;